import React, { useEffect, useRef, useState } from "react";

const STATS = [
  { value: 11000, suffix: "+", label: "Sq Ft" },
  { value: 2, suffix: "", label: "Event Rooms" },
  { value: 750, suffix: "", label: "Max Guests" },
  { value: 1, suffix: "", label: "Prep Kitchen", display: "Prep" },
  { value: 1, suffix: "", label: "Stage Options", display: "Flexible" },
  { value: 1, suffix: "", label: "Premium Lighting", display: "Premium" },
];

function Counter({ value, suffix, active }) {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!active) return;
    let start = 0;
    const dur = 1400;
    const t0 = performance.now();
    const step = (now) => {
      const p = Math.min((now - t0) / dur, 1);
      setN(Math.floor(p * value));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [active, value]);
  return <>{n.toLocaleString()}{suffix}</>;
}

export function FeatureStrip() {
  const ref = useRef(null);
  const [active, setActive] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => e.isIntersecting && setActive(true), { threshold: 0.3 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} data-testid="feature-strip" className="bg-epic-charcoal border-y border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 divide-x divide-white/5">
          {STATS.map((s, i) => (
            <div key={s.label} data-testid={`stat-${i}`} className="py-10 md:py-14 px-4 text-center">
              <div className="font-display text-4xl md:text-5xl text-epic-gold leading-none">
                {s.display ? s.display : <Counter value={s.value} suffix={s.suffix} active={active} />}
              </div>
              <div className="mt-3 text-[0.7rem] md:text-xs uppercase tracking-[0.2em] text-white/60">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
